/*
 * Module for the Service Purhase Redeposit partial view
*/

rs.module("content/participant/member/servicepurchase/redeposit",

    ["controls/components/event-banner"],

    function (eventBanner) {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, priorRefundGrid, editAllowed, selectedRefundBcpKey) {

            var form = $.js(jsSelectors.form);

            var _executeSelectionChanged = false;

            // when a prior refund is selected, load it into the form and reset it for calcualting
            priorRefundGrid.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged) {

                    if (editAllowed) {

                        // set button display back to initial
                        form.js(jsSelectors.interestCalc).hide();
                        form.js(jsSelectors.changeButton).hide();
                        form.js(jsSelectors.calculateButton).show();
                        form.js(jsSelectors.cancelButton).show();
                        form.js(jsSelectors.formActions).hide();
                        form.js(jsSelectors.saveButton).setDisabled();

                        // if a row is selected load its values into the form
                        if (values.length > 0) {

                            // disable form except for penalty end date field
                            toggleInputs(false);
                            form.js(jsSelectors.penaltyEndDate).prop("disabled", false);

                            // make the call to get the prior refund detail
                            $.get(
                                backendUrls.getPriorRefund,
                                {
                                    benefitclaimpaymentkey: values[0]
                                }

                            ).done(function (results) {

                                form.js(jsSelectors.refundDate).val(results.priorRefund.benefitEffectiveDate ? new Date(results.priorRefund.benefitEffectiveDate).toISODateString() : null);
                                form.js(jsSelectors.refundAmount).val(results.formattedRefundAmount);
                                form.js(jsSelectors.servicePurchased).val(results.priorRefund.serviceAmount);
                                form.js(jsSelectors.vestingServicePurchased).val(results.priorRefund.vestingServiceAmount);

                            });
                        }
                        else {
                            // if we are here, then a row is being unselected - enable and set form fields to defaults
                            toggleInputs(true);
                            form.js(jsSelectors.refundDate).val(null);
                            form.js(jsSelectors.refundAmount).val("$0.00");
                            form.js(jsSelectors.servicePurchased).val("0.00000");
                            form.js(jsSelectors.vestingServicePurchased).val("0.00000");
                        }
                    }
                    else {
                        // when editing is not allowed we want clicking a row to do nothing
                        // However, a row could be selected by default and we don't want that to change 
                        // so on click just keep setting the selected value to the original selected key (may be null, but that is ok)
                        priorRefundGrid.selectedValues = selectedRefundBcpKey;
                    }
                }

                _executeSelectionChanged = true;
            });

            // When the change parameters button is clicked reenable the form and hide the calculation section
            form.js(jsSelectors.changeButton, { required: false }).click(function () {

                _clearErrors();

                toggleInputs(true);
                form.js(jsSelectors.interestCalc).hide();

                form.js(jsSelectors.changeButton).hide();
                form.js(jsSelectors.calculateButton).show();
                form.js(jsSelectors.cancelButton).show();
                form.js(jsSelectors.formActions).hide();
                form.js(jsSelectors.saveButton).setDisabled();
            });

            // When calculate is clicked disable the form, send the request to calculate, and display the results
            form.js(jsSelectors.calculateButton, { required: false }).click(function () {

                // Validate form before performing calc
                var validator = form.closest("form").validate();
                var isValid = validator.form();

                if (isValid) {

                    // show loading spinner
                    form.js(jsSelectors.spinner).show();

                    // disabled the form fields
                    toggleInputs(false);

                    // make the call to calculate interest
                    $.get(
                        backendUrls.loadInterestCalc,
                        {
                            balance: form.js(jsSelectors.refundAmount).val(),
                            balanceDate: form.js(jsSelectors.refundDate).val(),
                            penaltyEndDate: form.js(jsSelectors.penaltyEndDate).val(),
                            editAllowed: editAllowed
                        }
                    ).done(function (results) {

                        form.js(jsSelectors.interestCalc).html(results).show();

                        form.js(jsSelectors.changeButton).show();
                        form.js(jsSelectors.calculateButton).hide();
                        form.js(jsSelectors.cancelButton).hide();
                        form.js(jsSelectors.formActions).show();
                        form.js(jsSelectors.saveButton).setDisabled(false);

                    }).fail(function () {

                        // if there was an error, re enable form fields, and show corresponding buttons
                        toggleInputs(true);
                        form.js(jsSelectors.interestCalc).hide();

                        form.js(jsSelectors.changeButton).hide();
                        form.js(jsSelectors.calculateButton).show();
                        form.js(jsSelectors.cancelButton).show();
                        form.js(jsSelectors.formActions).hide();
                        form.js(jsSelectors.saveButton).setDisabled();

                    }).always(function () {
                        // hide loading spinner
                        form.js(jsSelectors.spinner).hide();
                    });
                }
            });

            //
            // Enable/disable form inputs
            //
            function toggleInputs(enable) {

                form.js(jsSelectors.refundDate).prop("disabled", !enable);
                form.js(jsSelectors.refundAmount).prop("disabled", !enable);
                form.js(jsSelectors.servicePurchased).prop("disabled", !enable);
                form.js(jsSelectors.vestingServicePurchased).prop("disabled", !enable);
                form.js(jsSelectors.penaltyEndDate).prop("disabled", !enable);

                // if we are disabling the fields, copy their values into hidden fields so they can still be posted
                if (!enable) {
                    form.js(jsSelectors.refundDateHiddenField).val(form.js(jsSelectors.refundDate).val());
                    form.js(jsSelectors.refundAmountHiddenField).val(form.js(jsSelectors.refundAmount).val());
                    form.js(jsSelectors.servicePurchasedHiddenField).val(form.js(jsSelectors.servicePurchased).val());
                    form.js(jsSelectors.vestingServicePurchasedHiddenField).val(form.js(jsSelectors.vestingServicePurchased).val());
                    form.js(jsSelectors.penaltyEndDateHiddenField).val(form.js(jsSelectors.penaltyEndDate).val());
                }
            }

            //
            // Clear event banner and field errors
            //
            function _clearErrors() {

                // clear event banner
                eventBanner.removeAllMessages();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);